var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEC722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 8.5H12.25C10.1789 8.5 8.5 10.1789 8.5 12.25V19.75C8.5 21.8211 10.1789 23.5 12.25 23.5H19.75C21.8211 23.5 23.5 21.8211 23.5 19.75V12.25C23.5 10.1789 21.8211 8.5 19.75 8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9988 15.5287C19.0914 16.1529 18.9847 16.7904 18.6941 17.3505C18.4035 17.9106 17.9437 18.3648 17.38 18.6485C16.8164 18.9322 16.1776 19.0309 15.5546 18.9307C14.9316 18.8304 14.3561 18.5363 13.9099 18.0901C13.4637 17.6439 13.1696 17.0684 13.0694 16.4454C12.9691 15.8224 13.0679 15.1836 13.3515 14.62C13.6352 14.0563 14.0894 13.5965 14.6495 13.3059C15.2096 13.0153 15.8471 12.9086 16.4713 13.0012C17.108 13.0956 17.6974 13.3923 18.1526 13.8474C18.6077 14.3026 18.9044 14.892 18.9988 15.5287Z",
    stroke: "#FEC722",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 11.875H20.1325",
    stroke: "#FEC722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.9f95ec35c43f97f518c281a066dadd1e.svg";
export { ForwardRef as ReactComponent };